// src/components/ui/LoadingOverlay.jsx - Overlay de Loading Global
import { useEffect, useState } from 'react';
import logoPsiando from '@/assets/icon/logo_psiando.jpeg';


export const LoadingOverlay = ({ 
  message = 'Carregando...', 
  fullScreen = true,
  showSpinner = true,
  className = ''
}) => {
  const [dots, setDots] = useState('');

  // Animação dos pontos
  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => {
        if (prev === '...') return '';
        return prev + '.';
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const overlayClasses = fullScreen 
    ? 'fixed inset-0 z-50 bg-white bg-opacity-90 backdrop-blur-sm'
    : 'absolute inset-0 z-20 bg-white bg-opacity-75';

  return (
    <div className={`${overlayClasses} flex items-center justify-center ${className}`}>
      <div className="text-center">
        {/* Spinner */}
        {showSpinner && (
          <div className="mb-4">
            <PsiandoSpinner />
          </div>
        )}

        {/* Mensagem */}
        <div className="text-gray-700">
          <p className="text-lg font-medium mb-2">
            {message}{dots}
          </p>
          <p className="text-sm text-gray-500">
            Por favor, aguarde...
          </p>
        </div>
      </div>
    </div>
  );
};

// Logo circular — mesmo padrão do Header/MainLayout
const LogoCircle = ({ size = 64 }) => (
  <div style={{
    width: size, height: size,
    borderRadius: '50%',
    overflow: 'hidden',
    border: '3px solid var(--primary-accent)',
    boxShadow: '0 4px 16px rgba(26,92,88,0.25)',
    flexShrink: 0,
  }}>
    <img
      src={logoPsiando}
      alt="Psiando"
      style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
    />
  </div>
);

const PsiandoSpinner = () => (
  <div className="flex items-center justify-center">
    <div className="relative">
      <div className="absolute animate-spin" style={{
        inset: -8, borderRadius: '50%',
        border: '2px solid transparent',
        borderTopColor: 'var(--primary-accent)',
        borderRightColor: 'var(--secondary-light)',
        animationDuration: '2s',
      }} />
      <LogoCircle size={64} />
    </div>
  </div>
);

// LoadingSpinner é exportado de src/components/common/LoadingSpinner.jsx
// Re-exportado aqui para compatibilidade com imports existentes
export { LoadingSpinner } from '@/components/common/LoadingSpinner';

// Loading para botões - ATUALIZADO
export const ButtonLoading = ({ loading, children, ...props }) => {
  return (
    <button
      {...props}
      disabled={loading || props.disabled}
      className={`${props.className || ''} ${loading ? 'cursor-not-allowed opacity-75' : ''}`}
    >
      {loading ? (
        <div className="flex items-center justify-center">
          <LoadingSpinner size="sm" className="mr-2" />
          Carregando...
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export default LoadingOverlay;